module.exports = __webpack_public_path__ + "static/media/map.35a01b1d.png";